import { multi } from "@/utils/calc";

export const computedPrint = () => {
  let base: string = "2.473";
  return {
    width: Number(multi(base, localStorage.getItem('printWidth') || '0')) || 596,
    height: Number(multi(base, localStorage.getItem('printHeight') || '0')) || 346,
  }
};

export const initPrintSetting = () => {
  return {
    width: Number(localStorage.getItem('printWidth') || '0') || 241,
    height: Number(localStorage.getItem('printHeight') || '0') || 140,
  }
}